export const INSIGHTS_LOADING_VISIBLE_MS = 3200;

export const INSIGHTS_LOADING_ENTER_RAF_FRAMES = 2;

export const INSIGHTS_LOADING_MOTION_TRANSFORM_MS = 360;

export const INSIGHTS_LOADING_MOTION_OPACITY_MS = 280;

export const INSIGHTS_LOADING_TRANSITION_END_PROPERTY = "transform";

export const INSIGHTS_SKELETON_ROW_COUNT = 5;

export const INSIGHT_ROW_SKELETON_PLACEHOLDERS = {
    primary: { height: 16, width: 205 },
    tag: { borderRadius: 17, height: 16, width: 108 },
    trailing: { borderRadius: 6, height: 32, width: 32 },
} as const;
